import React from "react";
import { Field } from "formik";

import {
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import TabPanel from "../TabPanel";
import QueueSelect from "../QueueSelect";

/**
 * Tab "Integrações" — filas, Wavoip, integração e disparo de integração ao fechar.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Estados/handlers/datasets que não estão no Formik vêm por props.
 */
const IntegrationsTab = ({
  tab,
  classes,
  selectedQueueIds,
  handleChangeQueue,
  selectedPrompt,
  handleChangePrompt,
  triggerIntegrationOnClose,
  handleChange,
  integrationTypeId,
  handleIntegrationTypeChange,
  showWavoipCall,
  showIntegrations,
  showOpenAi,
  integrations,
  prompts,
}) => {
  return (
    <TabPanel className={classes.container} value={tab} name="integrations">
      <DialogContent dividers>
        <QueueSelect
          selectedQueueIds={selectedQueueIds}
          onChange={(selectedIds) => handleChangeQueue(selectedIds)}
        />
        {showWavoipCall && (
          <div>
            <Field
              as={TextField}
              label="Wavoip"
              fullWidth
              name="wavoip"
              variant="outlined"
              margin="dense"
            />
          </div>
        )}
        {showIntegrations && (
          <FormControl
            variant="outlined"
            margin="dense"
            className={classes.FormControl}
            fullWidth
          >
            <InputLabel id="integrationId-selection-label">
              {i18n.t("queueModal.form.integrationId")}
            </InputLabel>
            <Field
              as={Select}
              label={i18n.t("queueModal.form.integrationId")}
              name="integrationId"
              id="integrationId"
              variant="outlined"
              margin="dense"
              placeholder={i18n.t("queueModal.form.integrationId")}
              labelId="integrationId-selection-label"
            >
              <MenuItem value="">{"Desabilitado"}</MenuItem>
              {integrations.map((integration) => (
                <MenuItem key={integration.id} value={integration.id}>
                  {integration.name}
                </MenuItem>
              ))}
            </Field>
          </FormControl>
        )}
        {showOpenAi && (
          <FormControl margin="dense" variant="outlined" fullWidth>
            <InputLabel>{i18n.t("whatsappModal.form.prompt")}</InputLabel>
            <Select
              labelId="dialog-select-prompt-label"
              id="dialog-select-prompt"
              name="promptId"
              value={selectedPrompt || ""}
              onChange={handleChangePrompt}
              label={i18n.t("whatsappModal.form.prompt")}
              fullWidth
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
            >
              <MenuItem value={null}>
                {i18n.t("whatsappModal.menuItem.disabled")}
              </MenuItem>
              {prompts.map((prompt) => (
                <MenuItem key={prompt.id} value={prompt.id}>
                  {prompt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Grid spacing={3} container>
          <Grid xs={12} item>
            <FormControl
              variant="outlined"
              margin="dense"
              className={classes.FormControl}
              fullWidth
            >
              <InputLabel id="triggerIntegrationOnClose-selection-label">
                {i18n.t("whatsappModal.form.triggerIntegrationOnClose")}
              </InputLabel>

              <Field
                onChange={handleChange}
                value={triggerIntegrationOnClose}
                as={Select}
                label={i18n.t("whatsappModal.form.triggerIntegrationOnClose")}
                name="triggerIntegrationOnClose"
                id="triggerIntegrationOnClose"
                variant="outlined"
                margin="dense"
                placeholder={i18n.t(
                  "whatsappModal.form.triggerIntegrationOnClose"
                )}
                labelId="triggerIntegrationOnClose-selection-label"
              >
                <MenuItem value={false}>
                  {i18n.t("whatsappModal.menuItem.disabled")}
                </MenuItem>
                <MenuItem value={true}>
                  {i18n.t("whatsappModal.menuItem.enabled")}
                </MenuItem>
              </Field>
            </FormControl>
          </Grid>

          {triggerIntegrationOnClose && (
            <Grid xs={12} item>
              <FormControl
                variant="outlined"
                margin="dense"
                className={classes.FormControl}
                fullWidth
              >
                <InputLabel id="integrationType-selection-label">
                  {i18n.t("queueModal.form.integrationId")}
                </InputLabel>
                <Field
                  as={Select}
                  label={i18n.t("queueModal.form.integrationId")}
                  name="integrationType"
                  id="integrationType"
                  variant="outlined"
                  margin="dense"
                  placeholder={i18n.t("queueModal.form.integrationId")}
                  labelId="integrationType-selection-label"
                  value={integrationTypeId || ""}
                  onChange={handleIntegrationTypeChange}
                >
                  <MenuItem value="">{"Desabilitado"}</MenuItem>
                  {integrations
                    .filter(
                      (integration) =>
                        integration.type === "n8n" ||
                        integration.type === "typebot"
                    )
                    .map((integration) => (
                      <MenuItem key={integration.id} value={integration.id}>
                        {integration.name}
                      </MenuItem>
                    ))}
                </Field>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </TabPanel>
  );
};

export default IntegrationsTab;
